import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MenuItem } from './menu-item';

@Injectable({
  providedIn: 'root'
})
export class MenuItemService {

  private basePath = "api/v1/menu_item";
  constructor(
    private http: HttpClient
  ) { }

  private errorHandler(error:any): Promise<any> {
    console.error('An error occurred', error);
    return Promise.reject(error.error || error);
  }

  getMenuItems(): Promise<any> {
    let url = this.basePath;
    return this.http.get(url)
      .toPromise()
      .then( res => res as MenuItem[])
      .catch( error => this.errorHandler(error) );
  }
}
